import { isNil } from 'ramda';
import * as yup from 'yup';

import { CronJobName } from '../../CronJobsCRUDForm.types';

export const synchronisationCronJobsSchema = (jobType: CronJobName) =>
  yup.object().shape({
    cron: yup
      .string()
      .default('')
      .transform((item) => (isNil(item) ? '' : item)),
    ...(jobType === 'sync-employee-routes'
      ? SyncEmployeeRoutesConfigSchema
      : jobType === 'auto-send-to-flex'
      ? AutoSendToFlexConfigSchema
      : {})
  });

export const SyncEmployeeRoutesConfigSchema = {
  config: yup.object().shape({
    tenantId: yup.string().default(''),
    minusDays: yup.string().default(''),
    plusDays: yup.string().default('')
  })
};
export const AutoSendToFlexConfigSchema = {
  config: yup.object().shape({
    minutesBeforeStart: yup.number().default(0),
    functions: yup.string().default(''),
    reason: yup.string().default('')
  })
};
